import { LocalStorageKey } from "../../../types/local-storage/local-storage-key";
import { todayYYYYMMDD } from "../../../utils/date/date-format";
import { setIndexedDBItem, getIndexedDBItem } from "../../../utils/indexed-db/indexed-db-util";
import { createAsyncThunk } from '@reduxjs/toolkit';

export const loadOldAlerts = createAsyncThunk(
    'alert/loadOldAlerts',
    async (_, { rejectWithValue }) => {
      try {
        const today = todayYYYYMMDD;
        const oldAlertDate = localStorage.getItem(LocalStorageKey.AlertDate) || "";

        if (today !== oldAlertDate) {
          await setIndexedDBItem(LocalStorageKey.SchedulesNotStarted, "[]");
          await setIndexedDBItem(LocalStorageKey.DeliveryGroupsExpectedToBeDelayed, "[]");
          await setIndexedDBItem(LocalStorageKey.DeliveryGroupsCompletedWithDelay, "[]");
          await setIndexedDBItem(LocalStorageKey.DeliveryGroupsCompletedWithoutImage, "[]");
          localStorage.setItem(LocalStorageKey.AlertDate, today);
        }

        const oldExpectedDelayAlertsJson = await getIndexedDBItem(LocalStorageKey.DeliveryGroupsExpectedToBeDelayed) || "[]";
        const oldCompletedWithDelayAlertsJson = await getIndexedDBItem(LocalStorageKey.DeliveryGroupsCompletedWithDelay) || "[]";
        const oldCompletedWithoutImageAlertsJson = await getIndexedDBItem(LocalStorageKey.DeliveryGroupsCompletedWithoutImage) || "[]";
        const oldNotStartedAlertsJson = await getIndexedDBItem(LocalStorageKey.SchedulesNotStarted) || "[]";

        const oldExpectedDelayAlerts = JSON.parse(oldExpectedDelayAlertsJson);
        const oldCompletedWithDelayAlerts = JSON.parse(oldCompletedWithDelayAlertsJson);
        const oldCompletedWithoutImageAlerts = JSON.parse(oldCompletedWithoutImageAlertsJson);
        const oldNotStartedAlerts = JSON.parse(oldNotStartedAlertsJson);

        return {
          schedulesNotStarted: oldNotStartedAlerts,
          deliveryGroupsExpectedToBeDelayed: oldExpectedDelayAlerts,
          deliveryGroupsCompletedWithDelay: oldCompletedWithDelayAlerts,
          deliveryGroupsCompletedWithoutImage: oldCompletedWithoutImageAlerts,
        };
      } catch (error) {
        return rejectWithValue('Failed to load alerts');
      }
    }
);
